import React from "react";

type SuccessModalProps = {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
  subMessage?: string;
  imgSrc?: string; // ✅ Optional image source
};

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  onClose,
  message = "Thank you! Our team will contact you soon.",
  subMessage = "Interest Registered for:",
  imgSrc,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* ✅ Render image only if provided */}
          {imgSrc && (
            <img
              alt="Success"
              src={imgSrc}
              style={{ width: "30%", height: "auto", margin: "30px 0" }}
            />
          )}

          {/* Sub message */}
          <p
            style={{
              textAlign: "center",
              marginBottom: 10,
              lineHeight: "1.6",
            }}
          >
            {subMessage}
          </p>

          {/* Main message */}
          <h1 style={{ textAlign: "center", marginBottom: 10 }}>{message}</h1>

          <div
            onClick={onClose}
            style={{
              width: "100%",
              color: "#fff",
              height: 40,
              textAlign: "center",
              fontSize: 14,
              borderRadius: 10,
              userSelect: "none",
              cursor: "pointer",
              textTransform: "capitalize",
              background: "var(--primary-color)",
              fontFamily: "Lato-Bold",
              marginTop: 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Continue
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
